import { fontSize } from "config/styles/fonts";

const styles = {
  contentWrap: {
    position: "relative",
  },
  btn: {
    position: "sticky",
    bottom: "100%",
    left: "100%",
    zIndex: 1500,
    width: "150px",
    height: "56px",
    m: "20px 20px 0 0",
    fontSize: fontSize.l,
    textTransform: "capitalize",
    borderRadius: "50px",
  },
  modal: {
    position: "relative",
    top: 0,
    margin: "100px auto 0",
    minHeight: {
      xs: "100%",
      md: "400px",
    },
    height: {
      xs: "100%",
      md: "400px",
    },
    p: {
      xs: "20px 16px",
      md: "20px 36px",
    },
    zIndex: 1500,
    "& .MuiButtonBase-root.MuiIconButton-root": {
      display: "block",
      "&:hover": {
        backgroundColor: "unset",
      },
    },
  },
};

export default styles;
